import {
  Button,
  CircularProgress,
  CircularProgressLabel,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import LiveImage from "./LiveImage";
import LiveVideo from "./LiveVideo";

function TakePhotoVideoModal(props) {
  const type = props?.openModal?.type;

  return (
    <Modal isOpen={props?.openModal?.open} onClose={() => null} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalBody
          display={"flex"}
          alignItems="center"
          justifyContent={"center"}
          flexDirection="column"
          mb="10px"
        >
          {type === "photo" ? (
            <LiveImage {...props} />
          ) : type === "video" ? (
            <LiveVideo {...props} />
          ) : (
            ""
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default TakePhotoVideoModal;
